import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/manage/$siteId/wordpress')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/n/manage/$siteId/wordpress',
      params: { siteId: params.siteId },
      replace: true,
    });
  },
});
